import Button from '@atlaskit/button';

import { useAuth } from 'hooks';

interface ErrorPageProps {
  error?: Error;
}

export default function SomethingWentWrongPage({ error }: ErrorPageProps) {
  const { signOut } = useAuth();

  return (
    <div style={{ display: 'grid', gap: '32px', padding: '32px' }}>
      <h1 style={{ textAlign: 'center' }}>Something went wrong</h1>
      <Button
        appearance="primary"
        onClick={() => {
          signOut();
          window.location.reload();
        }}
      >
        Redirect to login page
      </Button>

      <div>
        <h2>Error Details:</h2>
        <div>{error?.message}</div>
        {error?.stack ? (
          <>
            <h3>Component Stack:</h3>
            <div>{error.stack}</div>
          </>
        ) : null}
      </div>
    </div>
  );
}
